import React from "react";
// import { motion } from "framer-motion";
import { Wrapper } from "./styled.jsx";

export const Footer = () => {
  return <Wrapper></Wrapper>;
};

export default Footer;
